import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_styles.scss'

class LayoutFourChannel extends Component {
  render() {
    const { groups = {} } = this.props;
    
    const poster1 = groups[0] || {};
    const poster2 = groups[1] || {};
    const poster3 = groups[2] || {};
    const poster4 = groups[3] || {};

    return (
      <div className="layout-four-channel">
        <div className="layout-four-channel__column-left">
          <div className='layout-four-channel__poster-landscape'>
            <img 
              src={poster1.images.large} 
              alt={poster1.title} 
            />
          </div>

          <div className='layout-four-channel__poster-landscape'>
            <img 
              src={poster2.images.large} 
              alt={poster2.title} 
            />
          </div>

          <div className='layout-four-channel__poster-landscape'>
            <img 
              src={poster3.images.large} 
              alt={poster3.title} 
            />
          </div>
        </div>
        <div className="layout-four-channel__column-right">
          <div className='layout-four-channel__poster-vertical'>
            <img 
              src={poster4.images.vertical} 
              alt={poster4.title} 
            />
          </div>
        </div>
      </div>
    );
  }
}

LayoutFourChannel.propTypes = {
  groups: PropTypes.array,
};

LayoutFourChannel.defaultProps = {
  groups: [],
};

export default LayoutFourChannel;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/Components/LayoutFourChannel/index.jsx